<template>
  <div>
    <div v-if='showGitMerged' class='section-title'>
      Ostatnie ukończone zadania
    </div>
    <template v-for='(item, index) in gitlabSummary.latest_merged'>
      <table class='table table-gitlab'>
        <tr>
          <td class='col1'>Tytuł</td>
          <td>{{ item.title }}</td>
        </tr>
        <tr>
          <td class='col1'>Czas utworzenia</td>
          <td>{{ getConvertedDate(item.created_at) }}</td>
        </tr>
        <tr>
          <td class='col1'>Czas aktualizacji</td>
          <td>{{ getConvertedDate(item.updated_at) }}</td>
        </tr>
        <tr>
          <td class='col1'>Zatwierdzone przez</td>
          <td>{{ item.merged_by.name }}</td>
        </tr>
        <tr>
          <td class='col1'>Link</td>
          <td>
            <a target="_blank" :href='item.web_url'>Przejdź</a>
          </td>
        </tr>
      </table>
      <div v-if='index !== gitlabSummary.latest_merged.length - 1' class='divider'></div>
    </template>

    <div v-if='showGitEvents' class='section-title'>
      Ostatnie wykonane akcje
    </div>
    <template v-for='(item, index) in gitlabSummary.latest_events'>
      <table class='table table-gitlab'>
        <tr>
          <td class='col1'>Akcja</td>
          <td>{{ item.action_name }}</td>
        </tr>
        <tr>
          <td class='col1'>Czas</td>
          <td>{{ getConvertedDate(item.created_at) }}</td>
        </tr>
        <tr>
          <td class='col1'>Typ</td>
          <td>{{ getEventType(item) }}</td>
        </tr>
        <tr>
          <td class='col1'>Tytuł</td>
          <td>{{ getEventTitle(item) }}</td>
        </tr>
        <tr>
          <td class='col1'>Cel</td>
          <td>{{ getEventRef(item) }}</td>
        </tr>
      </table>
      <div v-if='index !== gitlabSummary.latest_events.length - 1' class='divider'></div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';

moment.locale('pl');

export default {
  name: 'EmployeeGitStatus',
  props: ['gitlabSummary'],
  computed: {
    showGitMerged() {
      return this.gitlabSummary.username && this.gitlabSummary.latest_merged.length;
    },
    showGitEvents() {
      return this.gitlabSummary.username && this.gitlabSummary.latest_events.length;
    }
  },
  methods: {
    getConvertedDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    getEventType(item) {
      return item.target_type || 'Brak';
    },
    getEventTitle(item) {
      return item.target_title || (item.push_data || {}).commit_title || 'Brak';
    },
    getEventRef(item) {
      return (item.push_data || {}).ref || 'Brak';
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  text-align: center;
  color: #212529;
}

table td {
  border-width: 0px;
  padding: 0.5rem;
}

.table-gitlab .col1 {
  width: 33.33%;
}

.col1 {
  text-align: right;
  font-weight: 700;
}

.divider {
  border-top: 1px solid #dee2e6
}
</style>


// WEBPACK FOOTER //
// EmployeeGitStatus.vue?b2aa5ada